<div class="col-8 offset-2">
    <input type="file" multiple [imageToDataUrl]="options"  (imageSelected)="selectedImages($event);" class="m-img-upload-btn"  #input (change)="fileChange(input)" ng-file-model="input">
    <button class="btn btn-success btn-block" type="button" >
        <i class="fa fa-upload"></i> Choose images...
    </button>
</div>

<div class="card images-container">
    <div *ngFor="let image of renderImages; let i=index;" class="m-image-wrapper">
        <i class="fa fa-times m-delete-img" (click)="removeImage(i)"></i>
        <img [attr.src]="image"> 
    </div> 
</div>
